import Select from 'react-select'
import AsyncSelect from 'react-select/async';
import cx from "classnames";
import { useIntl } from "react-intl";
//Styles
import './select.scss';

const CustomSelect = (props) => {
    const { messages } = useIntl();
    const {
        options,
        isMulti,
        label,
        onChange,
        value,
        async,
        loadOptions,
        loading,
        required,
        getOptionLabel,
        getOptionValue,
        className,
        placeholder,
        disabled,
        menuPlacement,
        styles,
        ...rest
    } = props;

    if (!async) {
        return (
            <>
                <label className='input-normal-label'>{label}</label>
                <Select
                    className={`${className ? className : "react-select-container"}`}
                    isMulti={isMulti}
                    value={value || []}
                    name="colors"
                    options={options}
                    classNamePrefix="react-select"
                    onChange={(e) => {
                        onChange && onChange(e)
                    }}
                    placeholder={placeholder}
                    isDisabled={disabled}
                    menuPlacement={menuPlacement || "auto"}
                    styles={styles}
                    {...rest}
                />
            </>
        )
    } else {
        return (
            <>
                <label
                    className="input-normal-label"
                >
                    {label}
                    {required &&
                        <span className="text-danger"> *</span>
                    }
                </label>
                <AsyncSelect
                    className={cx('react-select-container', className)}
                    classNamePrefix="react-select"
                    defaultOptions
                    cacheOptions
                    isLoading={loading}
                    isSearchable
                    loadOptions={loadOptions}
                    isClearable
                    onChange={onChange}
                    getOptionLabel={getOptionLabel}
                    getOptionValue={getOptionValue}
                    placeholder={placeholder}
                    value={value}
                    isDisabled={disabled}
                    noOptionsMessage={() => messages['start_typing_to_search'] || 'Start typing to search'}
                    loadingMessage={() => `${messages['common_loading'] || 'Loading'}...`}
                    menuPlacement={menuPlacement || "auto"}
                    styles={styles}
                    {...rest}
                />
            </>
        )
    }
}
export default CustomSelect;